import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateAreaMutation as UpdateAreaMutationType,
  UpdateAreaMutationVariables,
} from "./__generated__/UpdateAreaMutation";

const UpdateAreaMutation = loader("./UpdateAreaMutation.gql");

type UpdateAreaMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: UpdateAreaMutationType) => void;
}) => ReactElement;

export const UpdateAreaMutationProvider: UpdateAreaMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<UpdateAreaMutationType, UpdateAreaMutationVariables>(UpdateAreaMutation, {
    errorPolicy: "none",
    onError,
    onCompleted,
  });

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
